const fiscalDataGateDictIT = {
  fiscalGateTitle: "Completa i tuoi dati fiscali",
  fiscalGateDescription:
    "Per continuare a usare la piattaforma e permetterci di emettere automaticamente la tua fattura elettronica, dobbiamo completare i tuoi dati fiscali.",
  personType: "Tipo di persona",
  personTypePhysical: "Persona fisica",
  personTypeLegal: "Persona giuridica",
  nomeFiscal: "Ragione sociale",
  fiscalDocumentNumber: "Documento fiscale (Codice Fiscale o Partita IVA)",
  fiscalDocumentNumberCPF: "CPF",
  fiscalDocumentNumberCNPJ: "CNPJ",
  fiscalDocumentNumberCodiceFiscale: "Codice Fiscale",
  fiscalDocumentNumberPartitaIVA: "Partita IVA",
  fiscalAddress: "Indirizzo",
  fiscalGateUnexpectedError: "Errore imprevisto durante il salvataggio dei dati fiscali.",
  fiscalGateSuccess: "Dati fiscali salvati con successo.",
};

export default fiscalDataGateDictIT;
